import React, { useEffect } from "react";
import TinySlider from "tiny-slider-react";
import "../../node_modules/tiny-slider/dist/tiny-slider.css";
import CardEcosistema from "./CardEcosistema";

import { useLocation } from "react-router-dom";
import ins from "../assets/images/sidom/fotos/02.png";
import sr from "../assets/images/sidom/fotos/03.png";
import pay from "../assets/images/sidom/fotos/04.png";
import msr from "../assets/images/sidom/fotos/05.png";
import misim from "../assets/images/sidom/fotos/06.png";
import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";

export default function Ecosistema() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  const ecosistemaData = [
    {
      icon: sr,
      title: "SIDOM Smart Reader",
      description:
        "Centralización, validación y almacenamiento de toda la documentación de comercio exterior. Optimice los tiempos operativos. Obtenga Compliance en los procesos al convertir tareas manuales en un proceso automático.",
      buttonText: "Conoce SIDOM Smart Reader",
      link: "/sidom-smart-reader",
    },
    {
      icon: ins,
      title: "SIDOM Insurance",
      description:
        "La primera solución InsurTech de Seguros embebidos para la gestión integral de las pólizas relacionadas con la operatoria de comercio exterior. Permite cotizar y contratar seguros de manera transparente y en tiempo real.",
      buttonText: "Conoce SIDOM Insurance",
      link: "/sidom-insurance",
    },
    {
      icon: pay,
      title: "SIDOM Pay",
      description:
        "Botón de pago que agiliza los procesos administrativos y financieros de las Empresas y los Agentes Aduanales. Con el uso de tecnología RPA, reduce un 100% los tiempos de pago y los errores derivados de la carga manual de datos.",
      buttonText: "Conoce SIDOM Pay",
      link: "/sidom-pay",
    },
    {
      icon: msr,
      title: "SIDOM MRE",
      description:
        "Administra regímenes de Importaciones Temporales, RAF, Saldos y Vencimientos de Stock, Registros de Insumos, etc. Desarrollos a medida para regímenes de cada país. Automatice alertas y notificaciones que previenen multas.",
      buttonText: "Conoce SIDOM MRE",
      link: "/sidom-mre",
    },
    {
      icon: misim,
      title: "SIDOM MiSIM",
      description:
        " Plataforma para Despachantes de Aduana integrada con Sistema María. Permite resolver las principales dificultades operativas a partir de la aplicación de tecnología IA y RPA.",
      buttonText: "Conoce SIDOM MiSIM",
      link: "/sidom-misim",
    },
  ];
  const eco = [...ecosistemaData, ...ecosistemaData];

  const settings = {
    items: 1,
    mouseDrag: true,
    loop: false,
    startIndex: 0,
    autoplay: false,
    speed: 400,
    autoplayTimeout: 5000,
    controls: true,
    nav: true,
    navPosition: "bottom",
    controlsText: [
      `<img src=${imgI} alt="Previous" class="w-6 h-6 md:w-8 md:h-8"/>`,
      `<img src=${imgD} alt="Next" class="w-6 h-6 md:w-8 md:h-8"/>`,
    ],
    gutter: 15,
    edgePadding: 10,
    responsive: {
      // Móviles pequeños (320px - 479px)
      0: {
        items: 1,
        gutter: 10,
        edgePadding: 5,
        nav: true,
        controls: true,
      },
      // Móviles medianos (480px - 639px)
      480: {
        items: 1,
        gutter: 15,
        nav: true,
        controls: true,
      },
      // Móviles grandes/Tablets pequeñas (640px - 767px)
      640: {
        items: 1,
        gutter: 10,
        nav: true,
        controls: true,
      },
      // Tablets (768px - 1023px)
      768: {
        items: 1.5,
        gutter: 20,
        nav: true,
        controls: true,
      },
      // Tablets grandes (1024px - 1199px)
      1024: {
        items: 2,
        gutter: 20,
        nav: true,
        controls: true,
      },
      // Desktop pequeño (1200px - 1399px)
      1200: {
        items: 2,
        gutter: 30,
        nav: true,
        controls: true,
      },
      // Desktop mediano (1400px - 1599px)
      1310: {
        items: 3,
        gutter: 30,
        nav: true,
        controls: true,
      },
      // Desktop grande (1600px+)
      1600: {
        items: 3,
        gutter: 60,
        nav: true,
        controls: true,
      },
    },
  };

  return (
    <div className="bg-gradient-to-t from-sidom-orange to-sidom-blue w-full h-full border border-sidom-orange dark:border-sidom-blue">
      <div data-aos="fade-up" data-aos-delay="800" className="container">
        <div className="w-full">
          <h1 className="text-2xl w-full sm:text-3xl md:text-[40px] lg:text-[45px] xl:text-[50px] leading-tight mt-[60px] sm:mt-[80px] md:mt-[100px] text-sidom-light font-extrabold mb-[40px] sm:mb-[50px] md:mb-[60px] text-left">
            Ecosistema{" "}
            <span className="text-sidom-orange text-3xl sm:text-4xl md:text-[50px] lg:text-[55px] xl:text-[60px] font-black">
              SIDOM
            </span>
          </h1>
        </div>

        <div className="bg-gradient-to-t from-transparent via-transparent to-transparent p-1 sm:p-2 mb-[60px] sm:mb-[80px] md:mb-[100px] relative">
          {/* Aquí se agregó la clase personalizada al contenedor del carrusel */}
          <div className="tiny-slider-wrapper overflow-hidden flex flex-row justify-center items-center  ecosistema-slider-unique">
            <TinySlider settings={settings}>
              {eco.map((item, index) => (
                <div key={index} className="px-2 sm:px-3 md:px-4">
                  <CardEcosistema
                    icon={item.icon}
                    title={item.title}
                    description={item.description}
                    buttonText={item.buttonText}
                    link={item.link}
                  />
                </div>
              ))}
            </TinySlider>
          </div>
        </div>
      </div>
    </div>
  );
}
